export default __webpack_public_path__ + "static/media/gameOver.72cef8bb.mp3";